import { render, staticRenderFns } from "./VideoProgress.vue?vue&type=template&id=49161890&scoped=true&"
import script from "./VideoProgress.vue?vue&type=script&lang=ts&"
export * from "./VideoProgress.vue?vue&type=script&lang=ts&"
import style0 from "./VideoProgress.vue?vue&type=style&index=0&id=49161890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49161890",
  null
  
)

export default component.exports